import { useEffect } from "react";
import '../Styles/Team.css';



const LinkedInIcon = () => (
 <img src="/assets/link.png" alt="LinkedIn" width="20" height="20" />
);

const coreTeam = [
  {
    id: "core-0",
    name: "Rajeshwaran P",
    role: "Founder & CEO",
    img: "/assets/raju.png", // ✅ fixed
    linkedin: "https://www.linkedin.com/in/rajeshwaran-p-🇮🇳-235266141"
  },
  {
    id: "core-1",
    name: "Bharathiraja T",
    role: "Director",
    img: "/assets/barathiraj.png", // ✅ fixed
    linkedin: "https://www.linkedin.com/in/bharathirajathangappalam?utm_source=share_via&utm_content=profile&utm_medium=member_android"
  },
  {
    id: "core-3",
    name: "Uma Maheshwari",
    role: "People & Business Partner",
   img:"/Team/Uma.jpg",// ✅ fixed
    linkedin: "https://linkedin.com/in/uma-maheswari-29449035",
  },
  {
    id: "core-2",
    name:  "Visukumar Gopal",
    role:"Strategy & Growth Partner",
   img: "/Team/Visukumar.jpg", // ✅ fixed
    linkedin: "https://linkedin.com/in/visukumar",
  },
  
  
];



const MemberCard = ({ member }) => {
  
  return (
    <div className="team-card">
      <div className="team-card__img-wrapper">
        <img src={member.img} alt={member.name} className="team-card__img" />
      </div>

      <div className="team-card__info">
        <div className="team-card__name-row">
          <span className="team-card__name">{member.name}</span>

          <a
            href={member.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="team-card__linkedin"
            aria-label="LinkedIn"
          >
            <LinkedInIcon />
          </a>
        </div>

        <div className="team-card__role">{member.role}</div>
      </div>
    </div>
  );
};

const SectionTitle = ({ title }) => (
  <div className="section-title-wrapper">
    <h2 className="section-title">{title}</h2>
    <div className="section-title__underline"></div>
  </div>
);

export default function TeamPage() {
  useEffect(() => {
    document.title = "Our Team | Outstanding Workplaces";
  }, []);
  return (
    <div className="team-page">
      <div className="team-container">

        <section className="team-section">
          <SectionTitle title="Core Team" />
          <div className="team-grid">
            {coreTeam.map((member) => (
              <MemberCard key={member.id} member={member} />
            ))}
          </div>
        </section>

       

      </div>
    </div>
  );
}